import { useState } from 'react';
import { LocationOption, TabType } from './types';
import { UserFilters } from '@/entities/admin/ui/users-filters/UsersFilters';
import type { AdminContentFilters, AdminContentSort } from '@/entities/admin/ui/content-list/types';
import { ArticleArticle, TournamentShort } from '@/api';
import { UserUser } from '@/api';

export const useAdmin = () => {
    const [tournaments, setTournaments] = useState<Array<TournamentShort>>();
    const [tournamentsLocations, setTournamentsLocations] = useState<LocationOption[]>();
    const [users, setUsers] = useState<Array<UserUser>>();
    const [playersLocations, setPlayersLocations] = useState<Record<number, { name: string; parent: string }>>();
    const [activeTab, setActiveTab] = useState<TabType>('tournaments');
    const [loading, setLoading] = useState(false);
    const [loadingUsers, setLoadingUsers] = useState(false);
    const [userFilters, setUserFilters] = useState<UserFilters>({});
    // No default sort: user must explicitly choose a column to sort by.
    const [userSort, setUserSort] = useState<{ key: 'reg_date' | 'last_updated'; order: 'asc' | 'desc' } | undefined>(
        undefined
    );
    const [userPagination, setUserPagination] = useState<{ limit: number; offset: number; total: number }>({
        limit: 5,
        offset: 0,
        total: 0,
    });
    // Dynamic list of available user roles (fetched from backend). Undefined until loaded.
    const [userRoles, setUserRoles] = useState<string[] | undefined>(undefined);

    // News state
    const [news, setNews] = useState<Array<ArticleArticle>>([]);
    const [loadingNews, setLoadingNews] = useState(false);
    const [newsFilters, setNewsFilters] = useState<AdminContentFilters>({});
    const [newsSort, setNewsSort] = useState<AdminContentSort | null>({ key: 'created_at', order: 'asc' }); // базовая сортировка по дате создания новости
    const [newsPagination, setNewsPagination] = useState<{ limit: number; offset: number; total: number }>({
        limit: 20,
        offset: 0,
        total: 0,
    });

    // Articles state
    const [articles, setArticles] = useState<Array<ArticleArticle>>([]);
    const [loadingArticles, setLoadingArticles] = useState(false);
    const [articlesFilters, setArticlesFilters] = useState<AdminContentFilters>({});
    const [articlesSort, setArticlesSort] = useState<AdminContentSort | null>({ key: 'created_at', order: 'desc' });
    const [articlesPagination, setArticlesPagination] = useState<{ limit: number; offset: number; total: number }>({
        limit: 20,
        offset: 0,
        total: 0,
    });

    return {
        tournaments,
        tournamentsLocations,
        users,
        playersLocations,
        activeTab,
        loading,
        loadingUsers,
        userFilters,
        setTournaments,
        setTournamentsLocations,
        setUsers,
        setPlayersLocations,
        setActiveTab,
        setLoading,
        setLoadingUsers,
        setUserFilters,
        userSort,
        setUserSort,
        userPagination,
        setUserPagination,
        userRoles,
        setUserRoles,
        // News
        news,
        setNews,
        loadingNews,
        setLoadingNews,
        newsFilters,
        setNewsFilters,
        newsSort,
        setNewsSort,
        newsPagination,
        setNewsPagination,
        // Articles
        articles,
        setArticles,
        loadingArticles,
        setLoadingArticles,
        articlesFilters,
        setArticlesFilters,
        articlesSort,
        setArticlesSort,
        articlesPagination,
        setArticlesPagination,
    };
};
